import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import type {HotspotExplorerHotspot} from "../types";
import {formatHotspotLocationLabel, formatHotspotSubtitle} from "../helpers";
import './hotspot-table.scss';

export type HotspotTableProps = {
    hotspots: HotspotExplorerHotspot[],
    onOpenHotspot: (locationId: string) => void
}

export function HotspotTable({hotspots, onOpenHotspot}: HotspotTableProps) {
    return (
        <div className="hotspot-table-wrap">
            <table className="hotspot-table">
                <thead>
                    <tr>
                        <th scope="col">Hotspot name</th>
                        <th scope="col">Location</th>
                        <th scope="col"># of visits</th>
                        <th scope="col">Species seen</th>
                        <th scope="col">Last visited</th>
                    </tr>
                </thead>
                <tbody>
                    {hotspots.length ? hotspots.map(hotspot => (
                        <tr key={hotspot.locationId}>
                            <td>
                                <button
                                    type="button"
                                    className="hotspot-table__name"
                                    onClick={() => onOpenHotspot(hotspot.locationId)}
                                >
                                    <span className="hotspot-table__name-icon" aria-hidden="true">
                                        <FontAwesomeIcon icon={faLocationDot} />
                                    </span>
                                    <span className="hotspot-table__name-text">
                                        <strong>{hotspot.location}</strong>
                                        {formatHotspotSubtitle(hotspot) ? <small>{formatHotspotSubtitle(hotspot)}</small> : null}
                                    </span>
                                </button>
                            </td>
                            <td>{formatHotspotLocationLabel(hotspot) || '--'}</td>
                            <td>{hotspot.visits.toLocaleString()}</td>
                            <td>{hotspot.speciesSeen.toLocaleString()}</td>
                            <td>{hotspot.lastVisited || '--'}</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={5} className="hotspot-table__empty">
                                No hotspots match the current filters.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
